<h2 mat-dialog-title>{{ 'TRANS__IMPORT__PLACE_TREE_TITLE' | translate }}</h2>

<mat-dialog-content>
  <div class="place-tree-dialog__tree">
    <app-primus-solr-tree-view
      [tabName]="'TRANS__SOLR_TREE_VIEW__PLACES_TAB_NAME'"
      [hideSearchTab]="true"
      searchInputLabel="TRANS__ADMIN__PLACE__SEARCH_INPUT_LABEL"
      [query]="query"
      secondaryLabelProp="place_type_id_value"
      [labelProp]="labelProp"
      [parentIdParentQueryPart]="parentIdParentQueryPart"
      [contextIdProp]="'materialized_paths.context_id'"
      [parentIdProp]="parentIdProp"
      [parentIdFlProp]="parentIdFlProp"
      [fullPathIdProp]="'materialized_paths.m_path'"
      [fullPathLabelProp]="'materialized_paths.full_path'"
      (selectionChanged)="onSelectionChanged($event)">
    </app-primus-solr-tree-view>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">
    {{ 'TRANS__IMPORT__PLACE_TREE_CANCEL' | translate }}
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="!selectedNode"
    (click)="confirm()">
    {{ 'TRANS__IMPORT__PLACE_TREE_CONFIRM' | translate }}
  </button>
</mat-dialog-actions>
